export default "__VITE_ASSET__DDF$w5Tb__"